import { apiInstance } from "./ApiInstance";

export const caseSearch = async (payload) => {
  let { data = {} } = await apiInstance.get(
    "/api/case/global-search?searchText=" + payload,
    payload
  );
  return data;
};

export const caseSearchApi = async (payload) => {
  let { data = {} } = await apiInstance.post("api/search", payload);
  return data;
};

export const getCimaCaseDetails = async (route, paylaod) => {
  let { data = {} } = await apiInstance.post(
    `api/case/get-cima-details/${route}`,
    paylaod
  );
  return data;
};
